const Home = () => import("@/views/Home");
const Student = () => import("@/views/Student");
const Privacy = () => import("@/views/Privacy");
const NotFound = () => import("@/views/Not-Found");

const routes = [
  {
    path: "/",
    component: Home
  },
  {
    path: "/student/:id",
    component: Student
  },
  {
    path: "/privacy",
    component: Privacy
  },
  {
    path: "*",
    component: NotFound
  }
];

export default routes;
